export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-primary-500 rounded-2xl overflow-hidden">
          <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-background-50 mb-4">
              随时随地看爆料
            </h2>
            <p className="text-base text-primary-100 leading-relaxed max-w-md mx-auto lg:mx-0 mb-8">
              下载51爆料移动客户端，每日爆料推送不遗漏。支持 iOS 与 Android 双平台，享受更流畅的浏览体验和独家推送通知，让热点永远快人一步。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-primary-600 font-semibold text-sm hover:bg-background-100 transition-all cursor-pointer no-underline whitespace-nowrap"
              >
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/15 text-background-50 font-medium text-sm border border-background-50/30 hover:bg-background-50/25 transition-all cursor-pointer no-underline whitespace-nowrap"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
          <div className="flex-1 flex justify-center lg:justify-end p-6 md:p-0">
            <div className="relative w-64 md:w-72 aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50/30">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20mobile%20app%20interface%20mockup%20with%20warm%20crimson%20and%20dark%20theme%2C%20news%20feed%20layout%20with%20card%20design%2C%20clean%20minimal%20UI%2C%20abstract%20data%20visualization%2C%20professional%20app%20design%20feel%2C%20no%20real%20text%20or%20lettering%2C%20atmospheric%20dark%20mode&width=720&height=1280&seq=app-mock-51bl&orientation=portrait"
                alt="51爆料移动客户端界面展示"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}